import React, { useMemo } from 'react';
import FormDrawer from "components/__new/common/form-drawer";
import { ButtonLoader, Input } from "components/__new/common/form";
import { ReactComponent as AddIcon } from "assets/images/icons/add-01.svg";
import { CustomSalaryBreakDown } from './CustomSalaryBreakDown';
import { generateUniqueId } from 'utils/generateUniqueId';
import Maybe from '../common/Maybe';
import { REGEX_VALUES } from 'utils/regexValues';

export const PayStructureFormStep1 = (props) => {
    const { formAction, form, setForm, handleTogglePayStructureModal, setIsOpen, step, setStep } = props;
    
    const totalSalaryBreakdown = useMemo(() => {
        return form.salary_breakdown.reduce((accumulator, currentValue) => +accumulator + +currentValue.percentage, 0);
    }, [form]);
    
    const handleAddNewCustomSalaryBreakdown = () => {
        setForm({
            ...form,
            salary_breakdown: [
                ...form.salary_breakdown,
                {
                    salary_component: "",
                    percentage: "",
                    is_default: false,
                    id: generateUniqueId(),
                },
            ]
        })
    }
    
    const handleUpdateSalaryBreakdown = (id, updatedData) => {
        setForm(prevState => {
            const newSalaryBreakdown = prevState.salary_breakdown.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        ...updatedData,
                    };
                }
                return item;
            });
            return {
                ...prevState,
                salary_breakdown: newSalaryBreakdown,
            };
        });
    };
    
    const isContinueButtonDisabled = useMemo(() => {
        const nonDefaultSalaryBreakdown = form.salary_breakdown.filter(salaryBreakdown => !salaryBreakdown.is_default);
            
        if (nonDefaultSalaryBreakdown.length > 0) {
            for (const customSalaryBreakdown of nonDefaultSalaryBreakdown) {
                if (!customSalaryBreakdown.salary_component || !customSalaryBreakdown.percentage) {
                    return true;
                }
            }
        }
        return !form.name || totalSalaryBreakdown !== 100;
    }, [form])
    
    return (
        <div className="p-6">
           <div className='relative'>
                <FormDrawer.Title
                    title={`${formAction === "create" ? "Add" : "Edit"} Pay Structure`}
                    description="Configure a new payroll structure here."
                    close={setIsOpen}
                />
                <div className='absolute right-0 top-0 flex items-center'>
                    <span className='text-[#00535C] font-medium text-[16px]'>{step}</span>
                    <span className='text-[#718096] font-medium text-[16px]'>/2</span>
                </div>
           </div>
        
            <div className="mt-8">
                <Input
                    type="text"
                    label="Structure Name"
                    placeholder="Enter Name of Structure"
                    value={form.name}
                    required
                    onChange={(e) => {
                        const { value } = e.target;
                        if (!REGEX_VALUES.LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY.test(value) || value.length > 50) {
                            return;
                        }
                        setForm({...form, name: value});
                    }}
                />
            
                <div className="pt-6 mt-4 border-t border-gray-100">
                    <h4 className='text-[#1A202C] font-bold text-[16px]'>Default Breakdown</h4>
                    <p className='text-[#718096] font-normal text-[16px]'>The total salary breakdown must sum up to 100%</p>
                </div>
                
                <div className='mt-8 flex justify-between items-center'>
                    {
                        form.salary_breakdown.filter(({ is_default }) => is_default).map(({ salary_component, percentage, is_default, id }) => {
                            
                            return (
                                <div key={`${salary_component}-${id}`} className='w-[30%]'>
                                    <h5 className='text-[#344054] font-medium text-[15px] capitalize'>{salary_component?.toLowerCase() || ""} (%)</h5>
                                    <Input
                                        type="number"
                                        label=""
                                        placeholder="Input Here"
                                        className="input-number"
                                        value={percentage}
                                        onChange={(evt) => {
                                            const { value } = evt.target;
                                           
                                            handleUpdateSalaryBreakdown(id, {
                                                salary_component,
                                                percentage: value,
                                                is_default,
                                                id,
                                            })
                                        }}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
                
                <Maybe condition={form.salary_breakdown.find(({ is_default }) => !is_default) || false}>
                    <CustomSalaryBreakDown 
                        form={form} 
                        setForm={setForm} 
                        handleUpdateSalaryBreakdown={handleUpdateSalaryBreakdown} 
                    />
                </Maybe>
                <div className='cursor-pointer flex items-center w-fit' onClick={handleAddNewCustomSalaryBreakdown}>
                    <AddIcon width={20} height={20} className='add-icon' />
                    <p className='font-medium ml-2' style={{ color: "#006770" }}>Add Custom Item</p>
                </div>
                
                <div className={`mt-5 flex justify-center items-center h-10 ${totalSalaryBreakdown < 100 ? "bg-[#FEF5E7]" : totalSalaryBreakdown > 100 ? "bg-[#DC2626]" : "bg-[#CFFFE3]"}`}>
                    <p style={{ color: "#1A202C"}}>Total Salary Breakdown is {totalSalaryBreakdown}%</p>
                </div>
                
                <div className="pt-10 mt-5 flex justify-end space-x-4 border-t border-gray-100">
                    <button 
                        type="button" 
                        onClick={handleTogglePayStructureModal} className="btn btn-lg btn-transparent-primary"
                    >
                        Cancel
                    </button>
                    <ButtonLoader 
                        className="btn btn-lg btn-ep-primary" 
                        disabled={isContinueButtonDisabled} 
                        onClick={() => setStep(2)}
                    >
                        Continue
                    </ButtonLoader>
                </div>
            </div>
        </div>
    )
}
